export const RoutePaths = {
    home: '/',
    notifications: '/notifications',
    tasks: '/tasks',
    sprintPlanning: '/sprints',
    epicPlanning: '/epics',
    sprintPlanningPage: '/sprint-planning',
    sprintsCreate: '/sprint-planning/sprints/create',
    epicsCreate: '/sprint-planning/epics/create',
    epicsAddTasks: '/sprint-planning/epics/:epicId/add-tasks',
    backlogCreate: '/sprint-planning/backlog/create',
    backlogDetailsSettings: '/sprint-planning/backlog/:backlogId/settings',
    backlogAddTasks: '/sprint-planning/backlog/:backlogId/add-tasks',
    newSprint: '/sprints/:sprintId',
    addTasksInSprint: '/sprints/:sprintId/add-tasks',
    myTasks: '/my/tasks',
    tasksBoard: '/tasks/board',
    companyTasks: '/company-tasks',
    projectUpdateDetail: '/projects/:projectId/status-updates/:statusUpdateId',
    projectUpdates: '/projects/:projectId/status-updates',
    projectSpaceDetail: '/projects/:projectId/spaces/:spaceId',
    projectSpaces: '/projects/:projectId/spaces',
    projectSpaceById: '/projects/:projectId/spaces/:spaceId',
    projectSpaceTabById: '/projects/:projectId/spaces/:spaceId/tabs/:spaceTabId',
    projectPlan: '/projects/:projectId/plan',
    sprintInProjectPlan: '/projects/:projectId/plan/sprints/:sprintId',
    sprintInProjectPlanTimeline: '/projects/:projectId/plan/timeline/sprints/:sprintId',
    projectPlanTimeline: '/projects/:projectId/plan/timeline',
    projectConversation: '/projects/:projectId/chat',
    projectConversationDetails: '/projects/:projectId/chat/:chatId',
    projectConversationDetailsResponsive: '/projects/:projectId/chat/:entityType/:chatId',
    projectTasks: '/projects/:projectId/tasks',
    projectTaskList: '/projects/:projectId/tasks/list',
    projectTaskBoard: '/projects/:projectId/tasks/board',
    projectFormResponses: '/projects/:projectId/forms/responses',
    projectFormResponseByInstance: '/projects/:projectId/forms/responses/:instanceId',
    projectFiles: '/projects/:projectId/files',
    projectTimesheet: '/projects/:projectId/timesheet',
    projects: '/projects',
    projectsV2: '/projects/v2',
    projectCreate: '/projects/create',
    projectCreateV2: '/projects/create-v2',
    projectDetail: '/projects/:projectId',
    projectOverview: '/projects/:projectId/overview',
    projectCustomerPortalConfiguration: '/projects/:projectId/customer-portal-configuration',
    projectFinancials: '/projects/:projectId/financials',
    projectInvoices: '/projects/:projectId/invoices',
    projectSettings: '/projects/:projectId/settings',
    activate: '/activate',
    loginWithSession: '/login-session',
    login: '/login',
    logout: '/logout',
    goodbye: '/goodbye',
    linkAction: '/link-action',
    newMagicLink: '/magiclink/new',
    magicLink: '/magiclink',
    customerPortalLogin: '/cp/embed',
    magicLink2fa: '/magiclink/2fa',
    setupProfile: '/setup-profile',
    forgotPassword: '/forgot-password',
    resetPassword: '/set-password',
    templates: '/templates',
    invoices: '/invoices',
    creditNotes: '/invoices/credit-notes',
    invoiceCreate: '/invoices/create',
    creditNoteCreate: '/credit-notes/create',
    invoiceCreditNoteCreate: '/invoices/:invoiceId/credit-note',
    invoiceApplyCreditNote: '/invoices/:invoiceId/apply-credit-note',
    invoiceEdit: '/invoices/:invoiceId/edit',
    creditNoteEdit: '/invoices/credit-notes/:creditNoteId/edit',
    individualInvoice: '/invoices/:invoiceId',
    individualCreditNote: '/invoices/credit-notes/:creditNoteId',
    individualCreditNoteApply: '/invoices/credit-notes/:creditNoteId/apply-credit-note',
    projectIndividualInvoice: '/projects/:projectId/invoices/invoices-detail/:invoiceId',
    projectIndividualCreditNote: '/projects/:projectId/invoices/credit-notes/credit-note-detail/:creditNoteId',
    invoiceEmail: '/invoices/:invoiceId/emails/:invoiceEmailId',
    creditNoteEmail: '/invoices/credit-notes/:creditNoteId/emails/:creditNoteEmailId',
    projectTemplateRoot: '/templates/projects',
    newProjectTemplate: '/templates/projects/new',
    documentTemplateRoot: '/templates/documents',
    newDocumentTemplate: '/templates/documents/new',
    newFormTemplate: '/templates/forms/new',
    formTemplate: '/templates/forms/:templateId',
    formTemplateRoot: '/templates/forms',
    sheetTemplate: '/templates/sheet',
    newSheetTemplate: '/templates/sheet/:id',
    savedAutomations: '/templates/saved-automations',
    savedAutomationById: '/templates/saved-automations/:savedAutomationId',
    newSavedAutomation: '/templates/saved-automations/new',
    customerPortalsList: '/templates/customer-portals',
    customerPortalCreateTheme: '/templates/customer-portals/create-theme',
    customerPortalThemeDrawer: '/templates/customer-portals/theme-drawer',
    customerPortalById: '/templates/customer-portals/:id',
    newcustomerPortal: '/templates/customer-portals/new',
    customerPortalByIdEditDrawer: '/templates/customer-portals/:id#ppi=:projectId/edit-theme',
    liveCustomerPortalWithoutProject: '/live-customer-portal-preview/',
    liveCustomerPortal: '/live-customer-portal-preview/:projectId',
    customerPortalThemeList: '/settings/customer-portal-themes',
    newCustomerPortalTheme: '/settings/customer-portal-themes/new',
    customerPortalThemeById: '/settings/customer-portal-themes/:themeId',
    aiFillTemplates: '/templates/ai-fill-templates',
    webForm: '/forms/:customerName/:instanceHash',
    statusUpdateTemplateRoot: '/templates/status-updates',
    newStatusUpdateTemplate: '/templates/status-updates/new',
    projectTemplate: '/templates/projects/:templateId',
    projectTemplateSettings: '/templates/projects/:templateId/settings',
    documentTemplate: '/templates/documents/:templateId',
    statusUpdateTemplate: '/templates/status-updates/:templateId',
    settings: '/settings',
    profile: '/settings/profile',
    organisationSettings: '/settings/organisation',
    holidayCalendarSettings: '/settings/holiday-calendar',
    teamMemberSettings: '/settings/team-members',
    skillMatrixSettings: '/settings/skill-matrix',
    newSkillFieldFromSkillMatrix: '/settings/skill-matrix/skill-fields/new',
    groupSettings: '/settings/groups',
    newGroup: '/settings/groups/new',
    groupDetail: '/settings/groups/:groupId/details',
    addMembersToGroup: '/settings/groups/:groupId/add-members',
    addBulkMembersToNewGroup: '/settings/groups/new/bulk',
    addBulkMembersToGroup: '/settings/groups/:groupId/add-bulk-members',
    removeBulkMembersFromGroup: '/settings/groups/:groupId/remove-bulk-members',
    removeMembersFromGroup: '/settings/groups/:groupId/remove-members',
    emailConfiguration: '/settings/email-configuration',
    customDomain: '/settings/custom-domain',
    globalAutomations: '/settings/automations',
    financials: '/settings/financials',
    newCustomRevenueRecognition: '/settings/financials/custom-revenue-recognition/:contractType/new',
    editCustomRevenueRecognition: '/settings/financials/custom-revenue-recognition/:contractType/:customRevenueRecognitionConfigId/edit',
    currency: '/settings/currency',
    security: '/settings/security',
    advanced: '/settings/advanced',
    api: '/settings/api',
    webhook: '/settings/webhook',
    newWebhook: '/settings/webhook/new',
    editWebhook: '/settings/webhook/:webhookId/edit',
    projectFields: '/settings/project-fields',
    archivedProjects: '/settings/archived-projects',
    taskFields: '/settings/task-fields',
    teamMemberFields: '/settings/team-member-fields',
    timeEntryFields: '/settings/time-entry-fields',
    expenseFields: '/settings/expense-fields',
    allocationFields: '/settings/allocation-fields',
    customerTeamMemberFields: '/settings/customer-team-member-fields',
    companyFields: '/settings/company-fields',
    budgetFields: '/settings/budget-fields',
    skillFields: '/settings/skill-fields',
    editProjectField: '/settings/project-fields/:fieldId/edit',
    editTaskField: '/settings/task-fields/:fieldId/edit',
    editTeamMemberField: '/settings/team-member-fields/:fieldId/edit',
    editCustomerTeamMemberField: '/settings/customer-team-member-fields/:fieldId/edit',
    editCompanyField: '/settings/company-fields/:fieldId/edit',
    editBudgetField: '/settings/budget-fields/:fieldId/edit',
    editSkillField: '/settings/skill-fields/:fieldId/edit',
    newProjectField: '/settings/project-fields/new',
    newTaskField: '/settings/task-fields/new',
    newTeamMemberField: '/settings/team-member-fields/new',
    editTimeEntryField: '/settings/time-entry-fields/:fieldId/edit',
    editExpenseField: '/settings/expense-fields/:fieldId/edit',
    editAllocationField: '/settings/allocation-fields/:fieldId/edit',
    newAllocationField: '/settings/allocation-fields/new',
    newCustomerTeamMemberField: '/settings/customer-team-member-fields/new',
    newCompanyField: '/settings/company-fields/new',
    newBudgetField: '/settings/budget-fields/new',
    newSkillField: '/settings/skill-fields/new',
    integrations: '/settings/integrations',
    timesheetSettings: '/settings/timesheets',
    addressSettings: '/settings/address',
    invoiceEssentialsSettings: '/settings/invoice/essentials',
    invoiceApprovalSettings: '/settings/invoice/approvals',
    invoiceApprovalChainCreate: '/settings/invoice/approvals/chain/create',
    invoiceApprovalChainEdit: '/settings/invoice/approvals/chain/:approvalTemplateId/edit',
    creditNoteApprovalSettings: '/settings/credit-notes/approvals',
    creditNoteApprovalChainCreate: '/settings/credit-notes/approvals/chain/create',
    creditNoteApprovalChainEdit: '/settings/credit-notes/approvals/chain/:approvalTemplateId/edit',
    expenseApprovalChainCreate: '/settings/expenses/approvals/chain/create',
    expenseApprovalChainEdit: '/settings/expenses/approvals/chain/:approvalTemplateId/edit',
    timesheetApprovalChainCreate: '/settings/timesheets/approvals/chain/create',
    timesheetApprovalChainEdit: '/settings/timesheets/approvals/chain/:approvalTemplateId/edit',
    invoiceCustomFieldsSettings: '/settings/invoice/custom-fields',
    taxCodesComponentCreate: '/settings/taxes/codes/component/create',
    taxCodesComponentEdit: '/settings/taxes/codes/component/:taxComponentId/edit',
    taxCodesCodeCreate: '/settings/taxes/codes/code/create',
    taxCodesCodeEdit: '/settings/taxes/codes/code/:taxCodeId/edit',
    newInvoiceField: '/settings/invoice-credit-notes-custom-fields/new',
    editInvoiceField: '/settings/invoice-credit-notes-custom-fields/:fieldId/edit',
    aiFillSettings: '/settings/ai-fills',
    rolesSettings: '/settings/roles',
    rateCards: '/settings/rate-cards',
    newRole: '/settings/roles/new',
    editRole: '/settings/roles/:roleId/edit',
    csatReports: '/reports/csat',
    reports: '/reports',
    notificationsSettings: '/settings/notifications',
    oldCustomerPortal: '/settings/old-customer-portal',
    oldCustomerPortalSettings: '/settings/customer-config',
    enableNewPortalSettings: '/settings/enable-new-portal',
    customerPortalEmbedSettings: '/settings/embed-customer-portal',
    customerPortalInviteConfigSettings: '/settings/customer-portal-invite-configuration',
    customerPortalNotificationSettings: '/settings/customer-portal/notifications',
    timesheets: '/timesheets',
    myTimesheets: '/timesheets/:week/my-timesheet',
    timesheetsApproval: '/timesheets/:week/approvals',
    timesheetsApprovalsList: '/timesheets/approvals-list',
    timesheetReports: '/reports/timesheets',
    dashboard: '/dashboards',
    dashboardById: '/dashboards/:dashboardId',
    newWidget: '/dashboards/:dashboardId/widgets/new',
    editWidget: '/dashboards/:dashboardId/widgets/:widgetId/edit',
    projectsReport: '/reports/projects',
    usersReport: '/reports/users',
    templateInsight: '/reports/operation',
    intervalsReport: '/reports/intervals',
    customReport: '/reports/custom-report/:customReportType/:customReportId',
    saveIntervalFromReports: 'reports/intervals/save-interval',
    portfolioReport: '/reports/portfolio',
    utilizationReport: '/reports/utilization',
    timesheetSubmissionReport: '/reports/timesheet-submission',
    userTimeAnalyticsReport: '/reports/user-time-analytics',
    projectTimeAnalyticsReport: '/reports/project-time-analytics',
    categoryTimeAnalyticsReport: '/reports/category-time-analytics',
    sprintsReport: '/reports/sprints',
    jiraIntegration: '/settings/integrations/jira',
    zapierIntegration: '/settings/integrations/zapier',
    workatoIntegration: '/settings/integrations/workato',
    salesforceIntegrations: '/settings/integrations/salesforce',
    salesforceIntegrationById: '/settings/integrations/salesforce/:integrationId',
    salesforceAutomations: '/settings/integrations/salesforce/:integrationId/automations',
    salesforceAutomationsNew: '/settings/integrations/salesforce/:integrationId/automations/new',
    salesforceAutomationsEdit: '/settings/integrations/salesforce/:integrationId/automations/:automationId/edit',
    salesforceResourceMapping: '/settings/integrations/salesforce/:integrationId/resource-mappings',
    salesforceErrorLogs: '/settings/integrations/salesforce/:integrationId/error-logs',
    salesforceSettings: '/settings/integrations/salesforce/:integrationId/settings',
    hubspotIntegration: '/settings/integrations/hubspot',
    hubspotIntegrationById: '/settings/integrations/hubspot/:integrationId',
    hubspotSettings: '/settings/integrations/hubspot/:integrationId/settings',
    hubspotResourceMappings: '/settings/integrations/hubspot/:integrationId/resource-mappings',
    resourceManagement: 'resource-management',
    slackIntegration: '/settings/integrations/slack',
    formTemplatePreview: '/form-preview/:formTemplateId',
    resourceManagementSettings: '/settings/resource-management',
    keyeventsAndIntervals: '/settings/keyevents-and-intervals',
    newKeyevent: '/settings/keyevents-and-intervals/events/new',
    editKeyevent: '/settings/keyevents-and-intervals/events/:eventId/edit',
    newInterval: '/settings/keyevents-and-intervals/intervals/new',
    editInterval: '/settings/keyevents-and-intervals/intervals/:intervalId/edit',
    billingSettings: '/settings/billing',
    partner: '/settings/partners',
    sprintSettings: '/settings/sprint-planning',
    sprintFields: '/settings/sprint-fields',
    newSprintField: '/settings/sprint-fields/new',
    editSprintField: '/settings/sprint-fields/:fieldId/edit',
    epicFields: '/settings/epic-fields',
    newEpicField: '/settings/epic-fields/new',
    editEpicField: '/settings/epic-fields/:fieldId/edit',
    partnerInformation: '/:id/view',
    partnerTeamMembers: '/:id/team-members',
    attachmentWorkspace: '/attachments/:attachmentId/workspace',
    respSpacesTab: '/responsive/:projectId/:spaceId/:spaceTabId',
    respStatusUpdate: '/project-updates-responsive/:projectId/:statusUpdateId',
    taskDesc: '/responsive-task-desc/:projectId/:taskId',
    taskDetailsResponsive: '/projects/:projectId/taskDetails/:taskId',
    addApiKey: '/add-api-key/:apiKey',
    attachmentWorkspaceSideBySide: '/attachments/:attachmentId/workspace/sidebyside/:compareAttachmentId',
    attachmentWorkspaceOverlay: '/attachments/:attachmentId/workspace/overlay/:compareAttachmentId',
    gpt: '/rocketlane-gpt',
    // Adding this just for dev and debugging purposes, donot use this is prod
    customAutomationLogsForAutomationId: '/custom-automation-logs/automation/:automationId',
    customerPorfolio: '/accounts',
    customerPorfolioDetail: '/accounts/:companyId',
    customerPorfolioOverview: '/accounts/:companyId/overview',
    customerPorfolioSettings: '/accounts/:companyId/settings',
    customerPorfolioPeople: '/accounts/:companyId/people/list',
    customerPorfolioEngagement: '/accounts/:companyId/engagement',
    customerPorfolioFinancials: '/accounts/:companyId/financials',
    customerPorfolioFiles: '/accounts/:companyId/files',
    customerPorfolioNitroPages: '/accounts/:companyId/nitro-pages',
    customerPorfolioNitroPageDetail: '/accounts/:companyId/nitro-pages/:nitroPageId',
    customerPorfolioMeetingPages: '/accounts/:companyId/meeting-pages',
    customerPorfolioMeetingPageDetail: '/accounts/:companyId/meetings/:meetingPageId',
    customerPorfolioEmailPages: '/accounts/:companyId/email-pages',
    customerPorfolioEmailPageDetail: '/accounts/:companyId/emails/:emailPageId',
    customerPorfolioSignalsV2: '/accounts/:companyId/signals',
    customerPorfolioList: '/accounts/list',
    customerPorfolioBoard: '/accounts/board',
    customerPorfolioSignals: '/accounts/signals',
    customerPorfolioSignalsAiAnalytics: '/accounts/signals',
    rmApps: '/resource-management/apps',
    teamPlanner: '/resource-management/apps/resource-ai',
    resourceRequest: '/resource-management/apps/resource-request',
    permissions: '/settings/permissions',
    newPermissionSet: '/settings/permissions/:permissionLevel/new',
    editPermissionSet: '/settings/permissions/:permissionLevel/:permissionId/edit',
    timesheetSingleUserApproval: '/timesheets/:week/approvals/:userId',
    outOfOffice: '/settings/out-of-office',
    customerPortalAttachmentById: '/projects/:projectId/attachments/:attachmentId',
    customerPortalSpaceTabById: '/projects/:projectId/spaces/:spaceId/tabs/:spaceTabId',
    customerPortalSheetById: '/projects/:projectId/sheets/:sheetId',
    customerPortalSheetByIdOverview: '/projects/:projectId/sheets/:sheetId/overview',
    customerPortalSheetByIdPivot: '/projects/:projectId/sheets/:sheetId/pivot/:pivotId',
    customerPortalSheetByIdTabs: '/projects/:projectId/sheets/:sheetId/tab/:selectedTabId',
    customerPortalInvoiceById: '/invoices/:invoiceId',
    cpShareLink: '/cp/share',
    billingEventList: '/projects/:projectId/settings/billing-schedule',
    billingEventCreate: '/projects/:projectId/settings/billing-schedule/billing-event/create',
    billingScheduleCreate: '/projects/:projectId/settings/billing-schedule/billing-schedule/create',
    billingScheduleImportTemplate: '/projects/:projectId/settings/billing-schedule/import-template',
    billingEventEdit: '/projects/:projectId/settings/billing-schedule/billing-event/:billingEventId/edit',
    myExpenses: '/expenses/my-expenses',
    myExpenseReports: '/expenses/my-expense-reports',
    expenseApprovals: '/expenses/approvals',
    expenseApprovalReports: '/expenses/approval-reports',
    revenueEntryOverview: '/revenue-entries/overview',
    revenueEntriesAll: '/revenue-entries/list'
};
export const KBLinks = {
    teamMembers: 'https://rocketlane.com',
    projectFields: 'https://rocketlane.com',
    taskFields: 'https://rocketlane.com',
    notificationsSettings: 'https://rocketlane.com',
    projectPlan: 'https://rocketlanecorp.freshdesk.com/support/solutions/articles/67000662876-creating-a-project-plan',
    projectPlanCustomer: 'https://rocketlanecorp.freshdesk.com/support/solutions/articles/67000659168-project-plan',
    projectPlanTemplate: 'https://rocketlanecorp.freshdesk.com/support/solutions/articles/67000659179-setting-up-templates',
    manageNotification: 'https://rocketlanecorp.freshdesk.com/support/solutions/articles/67000662878-managing-notifications',
    addingDocumentToProject: 'https://rocketlanecorp.freshdesk.com/support/solutions/articles/67000662922-adding-documents-to-your-project-on-rocketlane',
    statusUpdates: 'https://rocketlanecorp.freshdesk.com/support/solutions/articles/67000662877-adding-status-updates',
    statusUpdatesCustomer: 'https://rocketlanecorp.freshdesk.com/support/solutions/articles/67000659169-status-update',
    homeCustomer: 'https://rocketlanecorp.freshdesk.com/support/solutions/articles/67000659173-default-view-all-tasks',
    addTask: 'https://rocketlanecorp.freshdesk.com/support/solutions/articles/67000662880-adding-and-managing-tasks',
    helpCenter: 'https://help.rocketlane.com/support/home',
    rocketlaneAcademny: 'https://academy.rocketlane.com/'
};
export const ROCKETLANE_EMAILS = {
    support: 'care@rocketlane.com'
};
export const ROCKETLANE_PRIVACY = 'https://rocketlane.com/legal/privacy-policy';
export const PLACEHOLDER = '—';
export const ROCKETLANE_LOGIN = 'https://rocketlane.com/login';
export const ROCKETLANE_DEMO_MEETING = 'https://rocketlane.com/demo';
export const APP_CRASH_KEY = '__app_crash';
export const POTENTIAL_APP_CRASH_KEY = `__potential${APP_CRASH_KEY}`;
export const PROJECT_LIST_VIEW_QUERY_KEY = 'project-list-views';
export const TIMESHEET_LIST_VIEW_QUERY_KEY = [
    'views',
    'timesheet-approvals'
];
/**
 * SHA256('extraDetails) -> '8cfe65b6e9ba1f95284157e667703fb73b1fff322448ea14c6e6a31f97b2dbd2'
 * we need random string that user won't provide as regular field name
 */ export const EXTRA_DETAILS = '8cfe65b6e9ba1f95284157e667703fb73b1fff322448ea14c6e6a31f97b2dbd2';
export const BEAMER_URL = 'https://app.getbeamer.com/js/beamer-embed.js';
export const EDITOR_LOCK_KEY = 'editor-lock';
export const ROCKETLANE_WEBSITE = 'https://rocketlane.com';
export const LS_TEMPLATE_ID_KEY = '__blog_template';
export const COGNITO_ENABLED_KEY = 'COGNITO_ENABLED';
export const TOGGLE_ALLTASKS_SIDEBAR = 'toggle.allTasks.sidebar';
export const TOGGLE_PROJECTS_SIDEBAR = 'toggle.projects.sidebar';
export const SAVED_AUTOMATIONS_LEARN_MORE = 'https://help.rocketlane.com/support/solutions/articles/67000722964-what-are-saved-automations-and-how-to-use-them-';
export const GLOBAL_AUTOMATIONS_LEARN_MORE = 'https://help.rocketlane.com/support/solutions/articles/67000722962-setting-up-global-automations';
export const SETTINGS_WEBHOOKS_LEARN_MORE = 'https://developer.rocketlane.com/docs/webhooks-overview';
export const OTA_LS_KEY = 'OTA_LS_KEY';
export const ARROW_ASCII = '→';
export const LANGUAGE_SELECT = 'selected-language';
export const LANGUAGE_OVERRIDEN = 'language-overriden';
export const HIDE_DEPENDENCY_MODAL = 'hide.dependency.modal';
export const AWS_COGNITO_CLIENT_REGION = 'us-east-1';
export const LAST_PROJECT_PLAN_SUB_VIEW = 'lastProjectPlanSubView';
export const LAST_PROJECT_VIEW = 'lastProjectView';
export const AXIOS_CANCELLED_ERROR_CODE = 'ERR_CANCELED';
